import { BackofficeARIDTO, DailySet, ValueTypes } from "../types";
import { ARIBucketConfig, StaticExtraData } from "../../../../gen/witbooking/ari/v1/static_ari_pb";

interface DailyValues {
  rate?: {
    dailySet?: DailySet[];
    parentTicker?: string;
  };
  closed?: {
    dailySet?: DailySet[];
    parentTicker?: string;
  };
  availability?: {
    dailySet?: DailySet[];
    parentTicker?: string;
  };
}

const getDailyValue = (
  startDate: string,
  endDate: string,
  bucketConfig?: ARIBucketConfig.AsObject,
  ariElement?: {
    [key in ValueTypes]: {
      dailySet: DailySet[]
    }
  }
): DailyValues => {
  const result: DailyValues = {};
  if (bucketConfig?.rate && !bucketConfig.rate.parentTicker && !bucketConfig.rate.constant) {
    result.rate = {
      dailySet: ariElement?.rate?.dailySet || [{ startDate, endDate, value: 0 }],
      parentTicker: bucketConfig?.rate?.parentTicker
    };
  }
  if (bucketConfig?.lock && !bucketConfig.lock.parentTicker && !bucketConfig.lock.constant) {
    result.closed = {
      dailySet: ariElement?.closed?.dailySet || [{ startDate, endDate, value: false }],
      parentTicker: bucketConfig?.lock?.parentTicker
    };
  }
  if (bucketConfig?.availability && !bucketConfig.availability.parentTicker && !bucketConfig.availability.constant) {
    result.availability = {
      dailySet: ariElement?.availability?.dailySet,
      parentTicker: bucketConfig?.availability?.parentTicker
    };
  }
  return result;
};

export class ExtraData {
  ticker: string;
  dailyValues: DailyValues;

  constructor(ticker: string, dailyValues: DailyValues) {
    this.ticker = ticker;
    this.dailyValues = dailyValues;
  }

  static of(
    backofficeAriDto: BackofficeARIDTO,
    staticExtraData: StaticExtraData.AsObject[],
    startDate: string,
    endDate: string
  ): ExtraData[] {
    return staticExtraData
      .map(it => new ExtraData(
        it.ticker,
        getDailyValue(startDate, endDate, it.bucketConfig, backofficeAriDto[it.ticker])
      ))
      .filter(it => it.dailyValues.rate?.dailySet || it.dailyValues.closed?.dailySet || it.dailyValues.availability);
  }
}
